import { useEffect, useState } from "react"
import { motion } from "framer-motion"
import { ArrowLeft, Cpu, HardDrive, Smartphone, Tv, Zap } from "lucide-react"

export default function NotFound() {
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    setMounted(true)
  }, [])

  if (!mounted) return null

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-900 to-gray-800 flex flex-col items-center justify-center text-white p-4">
      <div className="max-w-3xl w-full text-center">
        <motion.div
          initial={{ opacity: 0, y: -50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="mb-8"
        >
          <h1 className="text-7xl md:text-9xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-green-800 via-green-500 to-green-100 mb-4">
            404
          </h1>
          <h2 className="text-2xl md:text-4xl font-bold mb-2">Página não encontrada</h2>
          <p className="text-gray-300 text-lg md:text-xl">
            Parece que esta pagina não existe, retorne para o site.
          </p>
        </motion.div>

        <motion.div
          className="flex justify-center mb-12"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.3, duration: 0.5 }}
        >
          <div className="relative w-64 h-64">
            {/* Círculo de ícones girando */}
            <motion.div
              className="absolute inset-0"
              animate={{ rotate: 360 }}
              transition={{ duration: 20, repeat: Number.POSITIVE_INFINITY, ease: "linear" }}
            >
              <motion.div
                className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2"
                whileHover={{ scale: 1.2 }}
              >
                <Smartphone className="w-10 h-10 text-blue-400" />
              </motion.div>
              <motion.div
                className="absolute top-1/2 right-0 translate-x-1/2 -translate-y-1/2"
                whileHover={{ scale: 1.2 }}
              >
                <Tv className="w-10 h-10 text-purple-400" />
              </motion.div>
              <motion.div
                className="absolute bottom-0 left-1/2 -translate-x-1/2 translate-y-1/2"
                whileHover={{ scale: 1.2 }}
              >
                <HardDrive className="w-10 h-10 text-pink-400" />
              </motion.div>
              <motion.div
                className="absolute top-1/2 left-0 -translate-x-1/2 -translate-y-1/2"
                whileHover={{ scale: 1.2 }}
              >
                <Cpu className="w-10 h-10 text-green-400" />
              </motion.div>
            </motion.div>

            {/* Ícone central pulsante */}
            <motion.div
              className="absolute inset-0 flex items-center justify-center"
              animate={{ scale: [1, 1.1, 1] }}
              transition={{ duration: 2, repeat: Number.POSITIVE_INFINITY }}
            >
              <div className="bg-gray-800 rounded-full p-6 shadow-lg shadow-blue-500/20">
                <Zap className="w-12 h-12 text-yellow-400" />
              </div>
            </motion.div>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.6, duration: 0.5 }}
        >
          <a href="/">
            <button
              className="group bg-transparent border-2 border-green-500 hover:bg-green-500/10 text-white px-6 py-3 rounded-md text-lg font-medium transition-colors flex items-center justify-center"
            >
              <motion.span
                className="mr-2"
                animate={{ x: [0, -4, 0] }}
                transition={{ duration: 1, repeat: Number.POSITIVE_INFINITY }}
              >
                <ArrowLeft className="w-5 h-5" />
              </motion.span>
              Voltar para a loja
            </button>
          </a>
        </motion.div>
      </div>
    </div>
  )
}